import EventEmitter from 'events';
class EditorEvents extends EventEmitter {
  constructor(editorId) {
    super();
    this.getEvent = event => "editor-".concat(this.editorId, "-").concat(event);
    this.editorId = editorId;
  }
  emit(event) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    super.emit.apply(this, [this.getEvent(event), ...rest]);
  }
  on(event) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }
    super.on.apply(this, [this.getEvent(event), ...rest]);
  }
}
export default EditorEvents;